import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  CurrencyField,
  Field,
  DateTimeField,
} from '../../../commons/DataTable';
import { useAuth } from '../../../commons/Auth';
import TotalTrainingTr from './TotalTrainingTr';
import TotalCertificationTr from './TotalCertificationTr';

function CertificationCalculationTable({ data, profile, query = {} }) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin }] = useAuth();
  const { offset, limit } = query;

  const table = [];

  if (
    profile?.isGoldCertified === true &&
    profile?.isPlatinumCertified === true
  ) {
    table.push(
      {
        nominative: 'Certificazione Gold',
        credits: 50,
      },
      {
        nominative: 'Certificazione Platinum',
        credits: 100,
      }
    );
  } else if (profile?.isGoldCertified === true) {
    table.push({
      nominative: 'Certificazione Gold',
      credits: 50,
    });
  } else if (profile?.isPlatinumCertified === true) {
    table.push({
      nominative: 'Certificazione Platinum',
      credits: 100,
    });
  }

  return (
    <DataTable
      offset={offset}
      limit={limit}
      data={table}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      bottomRow={
        <TotalCertificationTr
          totals={{
            creditsTotal: data || 0,
          }}
        />
      }
    >
      <Field
        title="Nome Certificazione"
        source="nominative"
        className="txt-table-center"
      />
      <Field title="Crediti" source="credits" className="txt-table-center" />
    </DataTable>
  );
}

export default withRouter(CertificationCalculationTable);
